import React, { Fragment, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    RadioGroup,
    Grid,
    Radio,
    Paper,
    FormLabel,
    FormControl,
    FormControlLabel,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemAvatar,
    colors,
    Avatar,
    Icon,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from '@material-ui/core';

import { BsSpeedometer2 } from "react-icons/bs";

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.blue[400],
        '&$checked': {
            color: colors.blue[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    fieldset: {
        margin: 8,
        width: '100%',
        maxHeight: 340,
        minHeight: 285,
        overflow: 'auto'
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    list: {
        width: '100%',
        maxHeight: 340,
        overflow: 'auto'
    }
}));

const Equipment = ({ item, open, closeEdition, updateValues, dependencies, checked, handleToggle }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md"  >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Equipamento
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                name: Yup.string().max(50).required('Nome é obrigatório'),
                                description: Yup.string().max(70).required('Descrição é o obrigatória'),
                                manufacturer: Yup.string().max(70).required('Fabricante é obrigatório'),
                                model: Yup.string().max(50).required('Modelo é obrigatorio'),
                                serial: Yup.string().max(50).required('Número Serial é obrigatório'),
                                device: Yup.string().max(50).required('Identificador MAC do Dispositivo é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            updateValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            label="Nome"
                                            margin="normal"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.description && errors.description)}
                                            fullWidth
                                            label="Descrição"
                                            margin="none"
                                            name="description"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.description}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.manufacturer && errors.manufacturer)}
                                            fullWidth
                                            label="Marca"
                                            margin="none"
                                            name="manufacturer"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.manufacturer}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.model && errors.model)}
                                            fullWidth
                                            label="Modelo"
                                            margin="none"
                                            name="model"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.model}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.serial && errors.serial)}
                                            fullWidth
                                            label="Identificação"
                                            margin="none"
                                            name="serial"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.serial}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.device && errors.device)}
                                            fullWidth
                                            label="Dispositivo"
                                            disabled={localStorage.getItem('profile') != 'ENG'}
                                            margin="none"
                                            name="device"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.device}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <Paper variant="outlined" rounded >
                                            <FormControl component="fieldset" required fullWidth >
                                                <FormLabel
                                                    style={{ padding: 10 }}
                                                    error={Boolean(touched.location && errors.location)}>
                                                    <b>Local de Instalação</b>
                                                </FormLabel>

                                                <Divider></Divider>

                                                <RadioGroup
                                                    required
                                                    className={classes.fieldset}
                                                    component={PerfectScrollbar}
                                                    name="localtion"
                                                    value={values.location}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}>

                                                    {dependencies.locations.map(local => {
                                                        return <FormControlLabel value={local._id} control={<Radio />} label={local.name + " - " + local.plan} />
                                                    })}

                                                </RadioGroup>
                                            </FormControl>
                                        </Paper>
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <Paper variant="outlined" rounded >
                                            <FormControl component="fieldset" fullWidth >
                                                <FormLabel style={{ padding: 10 }} >
                                                    <b>Painéis de Controle</b>
                                                </FormLabel>

                                                <Divider></Divider>

                                                <List dense className={classes.list} component={PerfectScrollbar}  >
                                                    {dependencies.panels.map((panel, index) => {
                                                        return (
                                                            <ListItem key={index} >
                                                                <ListItemAvatar>
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={BsSpeedometer2} style={{ color: colors.blue[500] }} ></Icon>}
                                                                    </Avatar>
                                                                </ListItemAvatar>
                                                                <ListItemText id={panel._id} primary={panel.message + ` [ ` + panel.code + ` ]`}
                                                                    secondary={`Nome: ` + panel.title} />
                                                                <ListItemSecondaryAction>
                                                                    <ColorCheckbox
                                                                        edge="end"
                                                                        onChange={handleToggle(panel._id, 'user')}
                                                                        checked={checked.indexOf(panel._id) != -1}
                                                                        inputProps={{ 'aria-labelledby': panel._id }}
                                                                    />
                                                                </ListItemSecondaryAction>
                                                            </ListItem>
                                                        );
                                                    })}

                                                </List>
                                            </FormControl>
                                        </Paper>
                                    </Grid>

                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeEdition() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Equipment;
